module.exports = __webpack_public_path__ + "static/img/Steve-Mortimer.263c9cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steve-Mortimer.jpg
// module id = A7jM
// module chunks = 0